module.exports = __webpack_public_path__ + "static/media/FreeEvents.de2815be.jpg";